import { DELETE, GET, POST, PUT } from "@store/methods";

// advance search fields
export const fetchAdvanceSearchFields = (params) => {
  return GET("/advance-search-fields", params);
};

// ipdate advance search fields
export const updateAdvanceSearchFields = (body) => {
  return PUT("/update-advance-search-fields", body);
};

// advance search fields
export const fetchPrimaryDropdowns = (params) => {
  return GET("/advance-search-primary-dropdowns", params);
};

// advance search
export const fetchAdvanceSearchResults = (params) => {
  return GET("/advance-search", params);
};

// save advance search
export const saveAdvanceSearch = (data, params) => {
  return POST("/save-advance-search-payload", data, params);
};

//get saved advance search
export const fetchSavedAdvanceSearchFilters = (params) => {
  return GET("/get-advance-search-payloads", params);
};

// delete advance search
export const deleteAdvanceSearch = (data, params) => {
  return DELETE("/delete-advance-search-payload", data, params);
};

// get possible correct importers and exporters
export const getCorrectImportersExporters = (data, params) => {
  return GET("/get-possible-correct-importers-or-exporters", data, params);
};
